import type { Transition, Variants } from "motion/react";

export const AUTH_ENTRY_DURATION_S = 0.22;
export const AUTH_ENTRY_OFFSET_PX = 8;

/** Action panel (light side) entrance. */
export function authEntryPanelMotion(reduceMotion: boolean): {
  variants: Variants;
  transition: Transition;
} {
  if (reduceMotion) {
    return {
      variants: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
      },
      transition: { duration: 0 },
    };
  }

  return {
    variants: {
      initial: { opacity: 0, y: AUTH_ENTRY_OFFSET_PX },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -AUTH_ENTRY_OFFSET_PX / 2 },
    },
    transition: {
      duration: AUTH_ENTRY_DURATION_S,
      ease: [0.22, 1, 0.36, 1],
    },
  };
}

const INSTANT_FADE: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0 } },
  exit: { opacity: 0, transition: { duration: 0 } },
};

/** Create Organization card or dialog panel: open and close. */
export function authEntryCreatePanelMotion(reduceMotion: boolean): Variants {
  if (reduceMotion) return INSTANT_FADE;

  return {
    initial: { opacity: 0, scale: 0.97, y: 10 },
    animate: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] },
    },
    exit: {
      opacity: 0,
      scale: 0.97,
      y: 8,
      transition: { duration: 0.22, ease: [0.4, 0, 0.6, 1] },
    },
  };
}

/** Chooser body swapped out for the Create card; a quick fade so the two never overlap. */
export function authEntryChooserViewMotion(reduceMotion: boolean): Variants {
  if (reduceMotion) return INSTANT_FADE;

  return {
    initial: { opacity: 0, y: AUTH_ENTRY_OFFSET_PX / 2 },
    animate: {
      opacity: 1,
      y: 0,
      transition: { duration: AUTH_ENTRY_DURATION_S, ease: [0.22, 1, 0.36, 1] },
    },
    exit: { opacity: 0, transition: { duration: 0.12, ease: "easeOut" } },
  };
}

/** Hero composition entrance: one restrained stagger, never a loop. */
export function authEntryStageMotion(reduceMotion: boolean): {
  container: Variants;
  item: Variants;
} {
  if (reduceMotion) {
    return {
      container: { hidden: {}, show: {} },
      item: { hidden: { opacity: 1 }, show: { opacity: 1 } },
    };
  }

  return {
    container: {
      hidden: {},
      show: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
    },
    item: {
      hidden: { opacity: 0, y: AUTH_ENTRY_OFFSET_PX },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: AUTH_ENTRY_DURATION_S, ease: [0.22, 1, 0.36, 1] },
      },
    },
  };
}
